import Player from '@vimeo/player';

const VimeoList = {
    activeVideoPlayer: null,
    modalIsOpen: false,

    init() {
        const vimeoButtons = document.querySelectorAll('[data-vimeo-video-id]');

        vimeoButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const vimeoId = btn.dataset.vimeoVideoId;
                const iframe = document.getElementById(vimeoId);
                const player = new Player(iframe);
                this.activeVideoPlayer = player;
                this.modalIsOpen = true;

                player.getPaused().then((isPaused) => {
                    if (isPaused) {
                        player.play()
                    } else {
                        player.setCurrentTime(0).then(() => {
                            player.play();
                        });
                    }
                });
            });
        });

        const closeButton = document.getElementById('close-button');
        closeButton?.addEventListener("click", () => {
            if (this.activeVideoPlayer) {
                this.activeVideoPlayer.pause();
                this.modalIsOpen = false;
            }
        });

        document.body.addEventListener('click', (event) => {
            if (this.modalIsOpen && !event.target.closest('.c-video-modal')) {
                if (this.activeVideoPlayer) {
                    this.activeVideoPlayer.setCurrentTime(0).then(() => {
                        this.activeVideoPlayer.play();
                    });
                }
            }
        });
    },
};

export default VimeoList;